module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/svgs/pattern_left_mobile-fff38021f8205a7a714c58ec63cb80e7.svg";